import React from 'react';
import { Link } from 'react-router-dom';

import {
  getToken
} from "constants/localStorageManager.js";
import 'assets/scss/landingPage.css';
import SocialIcons from './SocialIcons';

const LandingPageFooter = () => (
  <footer className="text-muted pt-4 pb-4">
    <div className="container">
      <p className="float-right">
        {!getToken() ? <a href="/#growBusiness">About Us</a> : null}
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-of-use">Terms and Conditions</Link>
      </p>
      <p>
        © {(new Date().getFullYear())} All rights reserved by <Link to="/home">Soono</Link>.
        <SocialIcons />
      </p>
    </div>
  </footer>
);

export default LandingPageFooter;



// WEBPACK FOOTER //
// ./src/components/LandingPage/Footer.js